<template>
  <div
    :id="id"
    class="flex-v-full">
    <div class="flex-v-full">
      <Breadcrumbs
        v-if="breadcrumbs"
        :items="breadcrumbs" />
      <div
        v-if="!isDetailsPage"
        class="main-content-header">
        <h1 :id="headerId">
          <div class="icon-label-and-actions">
            <div class="icon-and-label">
              <Component
                :is="icon"
                v-if="icon" />
              <slot
                v-else
                name="header-icon" />
              <editable-label
                class="page-template-label"
                :is-read-only="!canEditName"
                :label="capitalize(name)"
                button-size-class="btn-sm"
                @confirmed-change="(x) => emits('onEditName', x)" />
            </div>
            <div class="actions">
              <slot name="header-actions" />
            </div>
          </div>
        </h1>
      </div>
      <div class="page-message-info">
        <slot name="header-message" />
      </div>
      <div
        class="container-fluid details-container"
        :class="{ 'no-padding': noPadding }">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { capitalize, ComponentPublicInstance, computed } from 'vue';

  import Breadcrumbs from '@/org-app/components/controls/Breadcrumbs.vue';
  import EditableLabel from '@/org-app/components/controls/EditableLabel.vue';

  interface Breadcrumb {
    name: string;
    url?: string;
  }

  export interface IPageTemplateProps {
    id: string;
    icon?: ComponentPublicInstance;
    name?: string;
    breadcrumbs?: Breadcrumb[];
    isDetailsPage?: boolean;
    noPadding?: boolean;
    canEditName?: boolean;
  }
  interface IPageTemplateEmits {
    (e: 'onEditName', name: string): void;
  }

  const props = defineProps<IPageTemplateProps>();
  const emits = defineEmits<IPageTemplateEmits>();

  const headerId = computed<string>(() => `${props.id}_header`);
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .details-container.no-padding {
    padding: 0 !important;
  }

  .page-template-label {
    max-width: 48rem;
    font-weight: 600;
    font-size: 2.4rem;
  }

  .icon-and-label svg {
    top: unset !important;
  }

  .page-message-info {
    margin-inline: 2.4rem;
    margin-top: 1.5rem;
    font-size: 1.5rem;

    &:empty {
      display: none;
    }
  }
</style>
